<template>
  <div class="ShippingNow">
    <p class="Tips">
      {{ $t('subscription_details.replenishment.shippingNow.confirmText', 'Would you like to send your next shipping now ?') }}
    </p>

    <app-button
      type="submit"
      @click.prevent="onSubmitButtonClicked"
      :is-loading="shippingNowReplenishmentTask.isActive"
      data-name="shippingNowReplenishment-submitButton"
    >
      {{ $t('subscription_details.replenishment.shippingNow.button', 'Shipping Now') }} ›
    </app-button>

    <app-modal name="replenishmentShippingNow" width="500">
      <div class="v--modal-content">
        <h3 class="modal-title">
          {{ $t('subscription_details.replenishment.shippingNow.confirmationModal.title', 'Send next shipping now') }}
        </h3>

        <div class="modal-content">
          <p>
            {{
              $t('subscription_details.replenishment.shippingNow.confirmationModal.text', {
                defaultValue: 'Are you sure send next shipping now ?',
                billingPeriod: this.normalizedShippingFrequency
              })
            }}
          </p>

          <div class="modal-button-warpper">
            <app-button
              type="submit"
              @click.prevent="shippingNowReplenishmentTask.run()"
            >
              {{ $t('subscription_details.replenishment.shippingNow.confirmationModal.button.ok', 'Ok') }}
            </app-button>

            <app-button @click.prevent="onModalCancelled">
              {{ $t('subscription_details.replenishment.shippingNow.confirmationModal.button.cancel', 'Cancel') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utilities/common'
  import { lowerCase } from 'lodash'

  export default {
    name: 'replenishment-ship-now',

    props: {
      subscriptionNumber: {
        type: String,
        required: true
      },

      subscriptionRatePlanId: {
        type: String,
        required: true
      },

      shippingFrequency: {
        type: Object,
        required: true
      }
    },

    computed: {
      normalizedShippingFrequency () {
        const billingPeriod = this.shippingFrequency.billingPeriod
        const specificBillingPeriod = this.shippingFrequency.specificBillingPeriod
        return (specificBillingPeriod ? `${specificBillingPeriod + ' '}` : '') + lowerCase(this.$t(`subscription_details.replenishment.frequency.type.${billingPeriod}`, `${billingPeriod}`))
      }
    },

    tasks (t) {
      return {
        shippingNowReplenishmentTask: t(async function () {
          this.$bus.$emit('close-modal', 'replenishmentShippingNow')
          this.trackConversion({ name: 'interaction', description: 'popup:send_next_shipment_now:ok' })
          await Vue.api.subscription.shippingNowReplenishment(this.subscriptionNumber, this.subscriptionRatePlanId)
          this.$notify({
            type: 'success',
            title: this.$t('subscription_details.replenishment.shippingNow.success.message', 'Subscription has been updated. Your next replenishment will be shipped as soon as possible.')
          })

          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionNumber)
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }).flow('drop')
      }
    },

    methods: {
      onModalCancelled () {
        this.trackConversion({ name: 'interaction', description: 'popup:send_next_shipment_now:cancel' })
        this.$bus.$emit('close-modal', 'replenishmentShippingNow')
      },

      onSubmitButtonClicked () {
        this.trackConversion({ name: 'interaction', description: 'shipping_now' })
        this.trackConversion({ name: 'interaction', description: 'send_next_shipment_now:button:submit' })
        this.$bus.$emit('open-modal', 'replenishmentShippingNow')
      }
    }
  }
</script>
